import styled from 'styled-components';

export const FooterWrapper = styled.div`
  margin-top: 74px;
  color: rgba(0, 0, 0, 0.54);
  letter-spacing: 0;
  font-size: 0.75rem;
  @media only screen and (min-width: 992px) {
    margin-left: -15px;
    margin-right: -15px;
  }

  footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-top: 1rem;
  }

  footer p > :not(:last-child):after {
    content: '|';
    margin: 0px 20px;
    color: #a4c0e9;
  }

  a {
    color: rgba(0, 0, 0, 0.54);
    text-decoration: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/Footer/Footer.style.js